import { DisplayError, Guid, HtmlLink } from "@gemma/typescript-types";

import { Arrays } from "@gemma/utils";
import { GemmaError } from "@gemma/errors";
import Vue from "vue";
import { WebApplicationConstants } from "../setup/WebApplicationConstants";

export type IHasId = {
  id: Guid;
};

export type IHasValid = {
  valid: boolean;
};

export type IHasErrors = {
  errors: GemmaError[];
};

export type IValid = IHasErrors & IHasValid;

export function IsIHasValid(obj: any): obj is IHasValid {
  return Object.prototype.hasOwnProperty.call(obj, "valid");
}

export function IsIHasBus(obj: any): obj is IHasBus {
  return Object.prototype.hasOwnProperty.call(obj, "bus");
}

export type IHasBus = {
  bus: Vue;
};

export type IErrors = IHasErrors & Partial<IHasValid> & Partial<IHasBus> & Partial<IHasId>;

export type IClearErrors = {
  clearErrors: (this: IErrors) => void;
};

export function onClearErrors(this: IErrors): void {
  if (this.errors && this.errors.length > 0) {
    this.errors = [];
    if (IsIHasBus(this)) {
      this.bus.$emit("errors-cleared", this.id);
    }
  }
}

export { onClearErrors as clearErrors };

export function onErrors(this: IErrors & Vue, errors: GemmaError | GemmaError[]): void {
  if (IsIHasValid(this)) {
    this.valid = false;
  }

  Arrays.add(this.errors, errors);

  if (IsIHasBus(this)) {
    this.bus.$emit("errors", { id: this.id, errors: this.errors });
  } else {
    this.$emit("errors", errors);
  }
}

export function getDisplayErrors(errors: GemmaError<{ links?: HtmlLink[]; message?: string; isHTML: boolean; fieldName?: string }>[]): DisplayError[] {
  const _errors = errors
    .filter(error => error.ui !== false)
    .filter(error => (error.system || error.sensitive ? WebApplicationConstants.show.internalErrors : true))
    .map(error => {
      const e = {
        id: error.id,
        fieldName: error.data && error.data.fieldName,
        isHTML: false,
      } as DisplayError;

      if (error.data && error.data.links) {
        const split = error.message.split(":!");
        const before = split[0];
        const linkText = split[1];
        const after = split[2];
        e.links = [];
        const info = error.data.links[0];
        const type = info.href ? "anchor" : info.to ? "router" : undefined;

        const link: Partial<HtmlLink> = {
          after,
          before,
          linkText,
          rel: type === "anchor" ? info.rel : undefined,
          target: type === "anchor" ? info.target : undefined,
          type,
        };

        if (type === "anchor") {
          link.href = info.href;
        } else if (type === "router") {
          link.to = info.to;
        }

        e.links.push(link as HtmlLink);
      } else {
        e.message = error.message;
      }

      if (error.data && error.data.isHTML) {
        e.isHTML = error.data.isHTML;
      }

      if (error.system || error.sensitive) {
        // should await
        WebApplicationConstants.defaultLogger.error((error.innerError as GemmaError) || error);
      }

      return e;
    });

  if (_errors.length === 0 && errors.length > 0) {
    _errors.push({ id: GemmaError.DefaultError.id, message: GemmaError.DefaultError.message, isHTML: false });
  }

  return _errors;
}
